import { render, staticRenderFns } from "./Msglist.vue?vue&type=template&id=7b738867&scoped=true"
import script from "./Msglist.vue?vue&type=script&lang=js"
export * from "./Msglist.vue?vue&type=script&lang=js"
import style0 from "./Msglist.vue?vue&type=style&index=0&id=7b738867&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b738867",
  null
  
)

export default component.exports